import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { "data-testid": "project-ms-seeall-modal" };
const _hoisted_2 = { class: "text-base font-medium text-(--colors-text-heading) dark:text-white" };
const _hoisted_3 = { class: "text-sm text-(--colors-text-body-subtle)" };
const _hoisted_4 = {
    key: 0,
    class: "flex items-center justify-center py-16 text-sm text-(--colors-text-body-subtle)"
};
const _hoisted_5 = {
    key: 1,
    class: "py-16 text-center text-sm text-(--colors-text-body-subtle)"
};
const _hoisted_6 = {
    key: 2,
    class: "max-h-120 overflow-y-auto",
    role: "listbox",
    "aria-multiselectable": "true"
};
const _hoisted_7 = ["data-testid", "aria-selected", "onClick", "onKeydown"];
const _hoisted_8 = {
    "aria-hidden": "true",
    class: "shrink-0"
};
const _hoisted_9 = { class: "min-w-0 flex-1" };
const _hoisted_10 = { class: "truncate text-sm font-medium text-(--colors-text-black-default)" };
import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { Modal, Button, Checkbox } from "@eudonet/opal";
import { logger } from "@/infrastructure/services/LoggerService";
import { searchAllProjects } from "../../infrastructure/api/projects-api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProjectSeeAllModal',
    props: {
        modelValue: { type: Boolean },
        query: {},
        statuses: {},
        stagedIds: {}
    },
    emits: ["update:modelValue", "update:stagedIds", "validate"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const isOpen = computed({
            get: () => props.modelValue,
            set: (v) => emit("update:modelValue", v),
        });
        // Reload whenever the modal opens (covers v-show reuse; initial v-if mount handled below).
        watch(() => props.modelValue, (v) => { if (v)
            load(); });
        // Reload if the query changes while the modal is open (defensive; query is normally frozen).
        watch(() => props.query, () => { if (props.modelValue)
            load(); });
        const results = ref([]);
        const total = ref(0);
        const loading = ref(false);
        async function load() {
            loading.value = true;
            try {
                const page = await searchAllProjects(props.query, undefined, props.statuses);
                results.value = page.items;
                total.value = page.totalItems;
            }
            catch (err) {
                logger.error("ProjectSeeAllModal: load failed", err);
                results.value = [];
            }
            finally {
                loading.value = false;
            }
        }
        function isStaged(id) {
            return props.stagedIds.includes(id);
        }
        function toggle(id) {
            const next = isStaged(id) ? props.stagedIds.filter((v) => v !== id) : [...props.stagedIds, id];
            emit("update:stagedIds", next);
        }
        function close() {
            emit("update:modelValue", false);
        }
        function validate() {
            emit("validate");
            close();
        }
        if (props.modelValue)
            load();
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                size: "xl",
                dismissable: false,
                "aria-label": _unref(t)('campaigns.strategy.projectPicker.modalTitle', { count: total.value, query: __props.query }),
                onClose: close
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("campaigns.strategy.projectPicker.modalTitle", { count: total.value, query: __props.query })), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("campaigns.strategy.projectPicker.modalSubtitle")), 1 /* TEXT */)
                    ])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        "data-testid": "project-ms-seeall-close",
                        label: _unref(t)('campaigns.strategy.projectPicker.modalClose'),
                        onClick: close
                    }, null, 8 /* PROPS */, ["label"]),
                    _createVNode(_unref(Button), {
                        variant: "primary",
                        "data-testid": "project-ms-seeall-validate",
                        label: _unref(t)('campaigns.strategy.projectPicker.validate'),
                        "icon-left": "ri-check-line",
                        onClick: validate
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                default: _withCtx(() => [
                    (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _cache[1] || (_cache[1] = _createElementVNode("i", {
                                class: "ri-loader-4-line mr-2 animate-spin text-2xl",
                                "aria-hidden": "true"
                            }, null, -1 /* CACHED */)),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("campaigns.strategy.projectPicker.loading")), 1 /* TEXT */)
                        ]))
                        : (results.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)("campaigns.strategy.projectPicker.empty")), 1 /* TEXT */))
                            : (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (p) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: p.id,
                                        "data-testid": `project-ms-seeall-opt-${p.id}`,
                                        role: "option",
                                        "aria-selected": isStaged(p.id) ? 'true' : 'false',
                                        tabindex: "0",
                                        class: _normalizeClass(["flex cursor-pointer items-center gap-2.5 px-3 py-2 hover:bg-(--colors-background-hover) focus-visible:bg-(--colors-background-hover) focus-visible:outline-none", isStaged(p.id) ? 'bg-(--colors-background-selected)' : '']),
                                        onClick: ($event) => (toggle(p.id)),
                                        onKeydown: [
                                            _withKeys(_withModifiers(($event) => (toggle(p.id)), ["prevent"]), ["enter"]),
                                            _withKeys(_withModifiers(($event) => (toggle(p.id)), ["prevent"]), ["space"])
                                        ]
                                    }, [
                                        _createElementVNode("span", _hoisted_8, [
                                            _createVNode(_unref(Checkbox), {
                                                "model-value": isStaged(p.id),
                                                presentational: true
                                            }, null, 8 /* PROPS */, ["model-value"])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", _hoisted_10, _toDisplayString(p.name), 1 /* TEXT */)
                                        ])
                                    ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_7));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "aria-label"]));
        };
    }
});
